export const statusAdminsData = [
  {
    label: 'Todo',
    value: '',
  },
  {
    label: 'Activo',
    value: 'true',
  },
  {
    label: 'Inactivo',
    value: 'false',
  },
];

export const tableAdminsScheme = [
  {
    title: 'ID',
    width: '80px',
  },
  {
    title: 'Perfil',
    width: '80px',
  },
  {
    title: 'Nombre',
    minWidth: '180px',
    width: '200px',
  },
  {
    title: 'Correo',
    minWidth: '200px',
    maxWidth: '300px',
  },
  {
    title: 'No. Telefónico',
    minWidth: '200px',
  },
  {
    title: 'Estatus',
    minWidth: '60px',
  },
  {
    title: 'Info. adicional',
    minWidth: '200px',
  },
  {
    title: 'Creación',
    minWidth: '150px',
  },
  {
    title: 'Opciones',
    fixedRight: true,
    minWidth: '140px',
  },
];
